import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../auth';

// Wraps the entire /portal/* subtree.
// Non-customer users are redirected to the internal dashboard.
// Phase 3: swap useAuth() internals for real MSAL account resolution.
export default function PortalRedirect() {
  const { isCustomer } = useAuth();
  return isCustomer ? <Outlet /> : <Navigate to="/" replace />;
}
